export default __webpack_public_path__ + "static/media/greeting2.cb2a6c10.png";